/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxGamesLibWebRpcContractsResponseError
 */
export interface FxGamesLibWebRpcContractsResponseError {
    /**
     * 
     * @type {string}
     * @memberof FxGamesLibWebRpcContractsResponseError
     */
    Code: string;
    /**
     * 
     * @type {string}
     * @memberof FxGamesLibWebRpcContractsResponseError
     */
    Message: string;
    /**
     * 
     * @type {string}
     * @memberof FxGamesLibWebRpcContractsResponseError
     */
    RequestId: string;
}

/**
 * Check if a given object implements the FxGamesLibWebRpcContractsResponseError interface.
 */
export function instanceOfFxGamesLibWebRpcContractsResponseError(value: object): value is FxGamesLibWebRpcContractsResponseError {
    if (!('Code' in value) || value['Code'] === undefined) return false;
    if (!('Message' in value) || value['Message'] === undefined) return false;
    if (!('RequestId' in value) || value['RequestId'] === undefined) return false;
    return true;
}

export function FxGamesLibWebRpcContractsResponseErrorFromJSON(json: any): FxGamesLibWebRpcContractsResponseError {
    return FxGamesLibWebRpcContractsResponseErrorFromJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsResponseErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebRpcContractsResponseError {
    if (json == null) {
        return json;
    }
    return {
        
        'Code': json['Code'],
        'Message': json['Message'],
        'RequestId': json['RequestId'],
    };
}

export function FxGamesLibWebRpcContractsResponseErrorToJSON(json: any): FxGamesLibWebRpcContractsResponseError {
    return FxGamesLibWebRpcContractsResponseErrorToJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsResponseErrorToJSONTyped(value?: FxGamesLibWebRpcContractsResponseError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Code': value['Code'],
        'Message': value['Message'],
        'RequestId': value['RequestId'],
    };
}

